import React from "react";
import { renderToStaticMarkup } from "react-dom/server";
import { divIcon } from "leaflet";
import LeakIcon from "../Leak/components/LeakIcon";
import { ThemeProvider } from "@mui/material/styles";

export const createCustomMarker = (
  theme,
  status,
  severity,
  isSelected = false
) => {
  const leakIconElement = (
    <ThemeProvider theme={theme}>
      <LeakIcon
        status={status}
        severity={severity}
        isSelected={isSelected}
      />
    </ThemeProvider>
  );
  const leakIconHtml = renderToStaticMarkup(leakIconElement);
  return divIcon({
    html: leakIconHtml,
    className: isSelected ? "custom-marker selected" : "custom-marker",
    iconSize: [25, 25],
  });
};

export const parseLeaksToMarkers = (leaks, theme, selectedLeakId = null) => {
  return leaks.map((leak) => {
    const isSelected = selectedLeakId ? leak.id === selectedLeakId : false;
    const icon = createCustomMarker(
      theme,
      leak.properties.leak_status,
      leak.properties.leak_severity,
      isSelected
    );
    return {
      ...leak,
      icon,
      type: "LEAK",
    };
  });
};
